import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import React, { useRef } from 'react'

import { Button } from '@/components/ui/button'
import { faPaperclip } from '@/lib/fontAwesomePro/light'
import { cn } from '@/lib/utils'

interface Props {
  hasAddedFile: boolean
  multiple?: boolean
  // If `multiple` is true, `onAdd` will be invoked for each added file.
  onAdd: (file: File) => void
  // The file formats that are accepted
  accept?: string
}

const UploadFileButton: React.FC<Props> = ({
  onAdd,
  hasAddedFile,
  multiple,
  accept,
}) => {
  const fileInputRef = useRef<HTMLInputElement | null>(null)

  async function handleFileChange(event: React.ChangeEvent<HTMLInputElement>) {
    const files = Array.from(event.target.files || [])

    files.forEach((file) => {
      if (onAdd) {
        onAdd(file)
      }
    })
  }

  function renderText() {
    if (multiple) {
      return hasAddedFile
        ? 'Click here to add more files'
        : 'Click here to add files'
    }

    return hasAddedFile
      ? 'Click here to add a file'
      : 'Click here to add a file'
  }

  return (
    <>
      <Button
        variant="outline"
        size="lg"
        className={cn('flex w-full items-center justify-center gap-2 border', {
          'py-18': !hasAddedFile,
        })}
        style={{ minWidth: '170px' }}
        onClick={() => {
          fileInputRef.current?.click()
        }}
      >
        <FontAwesomeIcon
          role="button"
          icon={faPaperclip}
          style={{ fontSize: '20px' }}
        />
        {renderText()}
      </Button>

      <input
        ref={fileInputRef}
        multiple={multiple}
        type="file"
        name="file"
        onChange={handleFileChange}
        className="hidden"
        accept={accept}
      />
    </>
  )
}

export default UploadFileButton
